import React from 'react';
import { css } from 'emotion';
import { AccessibleErrorContainer } from 'client/components/AccessibleErrorContainer';
import { useT } from 'client/i18n/hooks/useT';

const AdsLoadingErrorBanner = ({
  onClickReload,
}: {
  onClickReload?: () => void;
}) => {
  const t = useT();
  return (
    <AccessibleErrorContainer
      className={css`
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 12px 0 0;
        color: #9a201c;
      `}
    >
      {t(
        'AdInsertion.AdsLoadingErrorBanner',
        'An error has occurred',
        'Ads loading error message'
      )}
      {onClickReload && (
        <button
          type="button"
          aria-label={t(
            'AdInsertion.ReloadAdsButtonAriaLabel',
            'click to reload ads',
            'Reload ads button screenreader information'
          )}
          className={css`
            text-decoration: underline;
          `}
          onClick={onClickReload}
        >
          {t(
            'AdInsertion.ReloadAdsButtonLabel',
            'reload ads',
            'Reload ads button text'
          )}
        </button>
      )}
    </AccessibleErrorContainer>
  );
};

export { AdsLoadingErrorBanner };
